/* Copyright Airship and Contributors */
'use strict';
/**
 * Enum of internal scoped subscription list update type.
 * @hidden
 */
var ScopedSubscriptionListOperationAction;
(function (ScopedSubscriptionListOperationAction) {
    ScopedSubscriptionListOperationAction["subscribe"] = "subscribe";
    ScopedSubscriptionListOperationAction["unsubscribe"] = "unsubscribe";
})(ScopedSubscriptionListOperationAction || (ScopedSubscriptionListOperationAction = {}));
/**
 * Scoped subscription list editor.
 */
export class ScopedSubscriptionListEditor {
    /**
     */
    constructor(onApply) {
        this.onApply = onApply;
        this.operations = [];
    }
    /**
     * Subscribes to a list in the given scope.
     *
     * @param subscriptionListId The subscription list identifier.
     * @param scope The subscription scope to subscribe.
     * @returns The editor.
     */
    subscribe(subscriptionListId, scope) {
        const operation = {
            listId: subscriptionListId,
            action: ScopedSubscriptionListOperationAction.subscribe,
            scope: scope,
        };
        this.operations.push(operation);
        return this;
    }
    /**
     * Unsubscribe from a list.
     *
     * @param subscriptionListId The subscription list identifier.
     * @param scope The subscription scope to unsubscribe.
     * @returns The editor.
     */
    unsubscribe(subscriptionListId, scope) {
        const operation = {
            listId: subscriptionListId,
            action: ScopedSubscriptionListOperationAction.unsubscribe,
            scope: scope,
        };
        this.operations.push(operation);
        return this;
    }
    /**
     * Applies subscription list changes.
     *
     */
    apply() {
        return this.onApply(this.operations);
    }
}
//# sourceMappingURL=ScopedSubscriptionListEditor.js.map